import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPaperclip2"><Path d="M6.75 8.75V16C6.75 18.8995 9.10051 21.25 12 21.25C14.8995 21.25 17.25 18.8995 17.25 16V5.375C17.25 3.92525 16.0747 2.75 14.625 2.75C13.1753 2.75 12 3.92525 12 5.375V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPaperclip2;
